<template>
<div class="mt_140">

<ccMenu ref="cc_menu" v-bind:posicao=1></ccMenu>
<ccLoading v-show="loading" ref="cc_loading"></ccLoading>

  <div class="container">

    <!-- Filtro/Visualizar-->
    <div class="row mb-3">
        <div class="col-2">
          <div class="form-group">
            <select class="form-control form-control-sm" v-model="frm_torneio_tipo" @change="filtro_tipo(frm_torneio_tipo)">
              <option value=0>Todos</option>
              <option value=1>Um contra o outro</option>
              <option value=2>Preço fixo</option>
              <option value=3>Torneio grátis</option>
            </select>
          </div>
        </div>

        <div class="col-2">
          <div class="form-group">
            <select class="form-control form-control-sm" v-model="frm_torneio_buy_in" @change="filtro_buy_in(frm_torneio_buy_in)">
              <option value="all">Valor de entrada</option>
              <option value="r1">0 - 5R$</option>
              <option value="r2">R$5 - R$30</option>
              <option value="r3">R$30 - R$100 </option>
              <option value="r4">R$100 - em diante  </option>
            </select>
          </div>
        </div>

        <div class="col-2">
          <div class="form-group">
            <select class="form-control form-control-sm" v-model="frm_torneio_next" @change="filtro_next(frm_torneio_next)">
              <option value="all">Próximos torneios</option>
              <option value="1H">Começa em 1 horas</option>
              <option value="2H">Começa em 2 horas</option>
              <option value="3H">Começa em 3 horas</option>
              <option value="24H">Começa em 24 horas</option>
              <option value="+24H"> Maior que 24 horas</option>
            </select>
          </div>
        </div>

        <div class="col-4 offset-2 text_branco text-end">
          Visualizar: &nbsp;
          <img src="../../assets/image/mosaic.png" width="20px" alt="..." @click="show_layout1()" style="cursor:pointer;"> &nbsp;
          <img src="../../assets/image/list.png" width="20px" alt="..." @click="show_layout2()" style="cursor:pointer;">
        </div>
    </div>

    <!-- tags ----------------------------------------------------------------------->
    <section class="mb-4">
      <div style="overflow-x: auto; display: flex;">
        <div class="mb-2" style="flex: 0 0 auto;">
          <div class="tag" v-for="tag of tags">
            <button class="btn btn-sm" @click="filtro_tag(tag.tag_id)" v-bind:class="[tag.tag_id==tag_id ? 'btn-warning' : 'btn-outline-warning']">
              {{tag.tag_nome}}
            </button>
          </div>
        </div>
      </div>
    </section>


    <!-- layout 1 ------------------------------------------------------------------>
    <section v-show="layout1">
        <div class="row p-0" style="background: transparent linear-gradient(163deg, #FFFFFF0D 0%, #80808000 100%) 0% 0% no-repeat padding-box;" v-show="this.original.length > 0">
            <div class="col-md-12 p-0">

                  <div class="mb-3">
                      <section id="torneio_free_destaque" class="p-4">
                          <ccCard ref="cc_card"></ccCard>
                      </section>
                  </div>

            </div>
        </div>
    </section>
    <!-- layout 1: fim ------------------------------------------------------------->


    <!-- layout 2 ------------------------------------------------------------------>
    <section v-show="layout2">
      <div class="row p-0" style="background: transparent linear-gradient(163deg, #FFFFFF0D 0%, #80808000 100%) 0% 0% no-repeat padding-box;">
          <div class="col-md-12 p-0">

              <section class="p-4">
                  <div class="col-12 mb-2">

                      <div class="row pb-2">
                          <div class="col-md-4 text_13 text_cinza"> Torneio </div>
                          <div class="col-md-2 text_13 text_cinza text-center"> Equivale a uma Odd: </div>
                          <div class="col-md-1 text_13 text_cinza text-cente"> Entradas/Max </div>
                          <div class="col-md-2 text_13 text_cinza text-center"> Começa em: </div>
                      </div>

                      <ccLista ref="cc_lista"></ccLista>

                  </div>
              </section>

          </div>
          </div>
    </section>
    <!-- layout 2: fim ------------------------------------------------------------->

    <!--TELA DE NENHUM TORNEIO-->
    <section class="p-4" v-show="this.original.length == 0" style="background: transparent linear-gradient(163deg, #FFFFFF0D 0%, #80808000 100%) 0% 0% no-repeat padding-box;">
        <div class="col-12 mb-2">
            <div class="text-center text_branco text_15 mb-3">
              <br><br>
              Não existe nenhum torneio ativo no momento <br>
              Use o filtro acima para ver mais torneios ou
                  <router-link to="/home/torneio/0"><b class="text_verde" style="text-decoration:none;">clique aqui</b></router-link>
              para ver torneios das próximas horas
              <br><br>
            </div>

        </div>
    </section>
    <!--TELA DE NENHUM TORNEIO: FIM-->



  <ccAlert ref="cc_alert"></ccAlert>

</div>

<ccFooter></ccFooter>
</div>
</template>

<script>

import axios from 'axios';
import ccMenu from '../layout/menu.vue'
import ccFooter from '../layout/footer.vue'
import ccMensagem from '../cc_geral/mensagem.vue'
import ccAlert from '../cc_geral/cc_alert.vue'
import ccLoading from '../cc_geral/cc_loading.vue'
import ccCard from './home_torneio_cc_card.vue'
import ccLista from './home_torneio_cc_lista.vue'
import Cookies from 'js-cookie'

export default {
  data () {
    return {
      //socket
      socket : {},
      canal : "canal_home_torneio",
      countSocket: 0,
      fala_servidor: null,
      fonte: null,

      //geral
      base_url_api: process.env.BASE_URL_API,
      user: {},
      loading: true,
      errors: [],

      //array
      original: [],
      torneio: [],
      tags: [],

      //filtro
      frm_torneio_tipo: 2,
      frm_torneio_buy_in: 'all',
      frm_torneio_next: 'all',
      timer_torneio_horario: null,

      //layout
      layout1: false,
      layout2: true,

      //variaveis
      tag_id: 0,
    }
  },

  components: {ccMenu, ccFooter, ccMensagem, ccAlert, ccLoading, ccCard, ccLista},

  created(){
    document.title = 'Torneios - SokkerDuel';

    localStorage.setItem("base_url_api_mobile", this.base_url_api)

    let layout_card = Cookies.get('sokkerduel_layout_card');
    if(layout_card != undefined || layout_card != null){
      if(layout_card == 1){
        this.layout1 = true
        this.layout2 = false
      }else{
        this.layout1 = false
        this.layout2 = true
      }
    }

    this.frm_torneio_tipo = this.$route.params.tipo_id
    this.tag_id = this.$route.params.tag_id
    this.escute_canal()
  },

  mounted(){
    let a = JSON.parse(localStorage.getItem("user"));

    if (a == null){
      this.user = {}
    }else{
      this.user = a
    }

    this.get_all_torneio_abertos()
    this.start_time()
  },

  methods: {

      escute_canal(){
        this.socket = this.$store.state.socket;

        //quantos logados no socket
        this.socket.on('countSocket', (data) => {
          this.countSocket = data;
        });

        this.socket.on( this.canal, (data) => {
            this.fonte = data.fonte
            this.original = data.resp.torneios;
            this.higienizar()
        });
      },

      get_all_torneio_abertos(){
        this.loading = true;
        var header = {'headers': {'x-access-token': this.user.access_token, }};
        axios.get(this.base_url_api+'home/torneio', header)
        .then(response => {
          this.fonte = response.data.fonte
          this.original = response.data.resp.torneios;
          this.tags = response.data.resp.tags;

          //verifique se existe alguma tag selecionada para esta pagina 
          //senao jogue para a tela do turbo
          if(this.tag_id > 0){
            var found = this.tags.filter((item) => item.tag_id == this.tag_id)

            // Se encontrou a tag
            if (found.length > 0) {
              console.log(found);
            } else {
              // console.log("Nenhuma tag encontrada");
              this.$router.push({ path: '/turbo/'+this.tag_id, replace: true })
            }
          }

          this.higienizar()
          this.loading = false;
        })
        .catch(e => {
          this.errors.push(e);
        });
      },

      higienizar(){
        let agora = Date.now()
        let a = this.original
        var obj = {}
        this.tor = []
        let dif = 0;
        this.torneio = []
        let aux = []
        let aux2 = []

        //filtro tipo
        for (var i=0; i <= a.length -1; i++){

            if(a[i].qtd_aposta < a[i].max_pessoa){
                if( a[i].tipo_id == this.frm_torneio_tipo || this.frm_torneio_tipo == 0 ){

                  dif = ( (a[i].dt_inicio_timestamp * 1000) - agora )
                  dif = parseInt(dif/1000);

                  obj = {
                    id :a[i].id,
                    nome :a[i].nome,
                    tipo_id :a[i].tipo_id,
                    sumario :a[i].sumario,
                    dt_inicio_timestamp :a[i].dt_inicio_timestamp,
                    dt_termino_timestamp :a[i].dt_termino_timestamp,
                    descricao_pagamento :a[i].descricao_pagamento,
                    odd :a[i].odd,
                    taxa_entrada :a[i].taxa_entrada,
                    min_pessoa :a[i].min_pessoa,
                    max_pessoa :a[i].max_pessoa,
                    max_reentrada :a[i].max_reentrada,
                    qtd_aposta :a[i].qtd_aposta,
                    qtd_jogo :a[i].qtd_jogo,
                    qtd_mercado_obrigatorio :a[i].qtd_mercado_obrigatorio,
                    prize :a[i].prize,
                    status :a[i].status,
                    status_nome :a[i].status_nome,
                    destaque :a[i].destaque,
                    jogo: a[i].jogo,
                    dif: dif,
                    time_regressivo: 0,
                    tag_id: a[i].tag_id,
                    tag_nome: a[i].tag_nome,
                  }

                  aux.push(obj);
                }
            }
        }

        //retire todos os dif = 0, ou seja acabou o tempo
        aux = aux.filter((item) => item.dif > 0)

        //filtro buy_in
        if (this.frm_torneio_buy_in == 'r1') {
          aux = aux.filter((item) => item.taxa_entrada > 0  && item.taxa_entrada <= 5)
        } else if (this.frm_torneio_buy_in == 'r2') {
          aux = aux.filter((item) => item.taxa_entrada > 5  && item.taxa_entrada <= 30)
        } else if (this.frm_torneio_buy_in == 'r3') {
          aux = aux.filter((item) => item.taxa_entrada > 30  && item.taxa_entrada <= 100)
        } else if (this.frm_torneio_buy_in == 'r4') {
          aux = aux.filter((item) => item.taxa_entrada > 100)
        }

        //filtro next
        if( this.frm_torneio_next == '1H'){
          aux = aux.filter((item) => item.dif <= 3600)
        } else if( this.frm_torneio_next == '2H'){
          aux = aux.filter((item) => item.dif <= 3600 * 2)
        } else if( this.frm_torneio_next == '3H'){
          aux = aux.filter((item) => item.dif <= 3600 * 3)
        } else if( this.frm_torneio_next == '24H'){
          aux = aux.filter((item) => item.dif <= 3600 * 24)
        }

        //filtro de tags
        if( this.tag_id != 0){
          aux = aux.filter((item) => item.tag_id == this.tag_id)
        }

        this.torneio = aux

        this.$refs.cc_card.receber_dados(this.torneio)
        this.$refs.cc_lista.receber_dados(this.torneio)

      },

      filtro_tipo(tipo){
        this.frm_torneio_tipo = tipo
        this.higienizar()
      },

      filtro_buy_in(buy_in){
        this.frm_torneio_buy_in = buy_in
        this.higienizar()
      },

      filtro_next(next){
        this.frm_torneio_next = next
        this.higienizar()
      },

      show_layout1(){
        this.layout1 = true
        this.layout2 = false
        Cookies.set('sokkerduel_layout_card', 1, { expires: 30 } )
      },

      show_layout2(){
        this.layout1 = false
        this.layout2 = true
        Cookies.set('sokkerduel_layout_card', 2, { expires: 30 } )
      },

      start_time(){
        this.timer_torneio_horario = setInterval( function() {
          for (var i=0; i < this.torneio.length; i++) {
            this.torneio[i].dif = this.torneio[i].dif - 1
            this.torneio[i].time_regressivo = this.timestamp_horas_minutos_segundos( this.torneio[i].dif )
          }
        }.bind(this), 1000);
      },

      filtro_tag(tag_id){
        if(this.tag_id == tag_id){
          this.tag_id = 0
        }else{
          this.tag_id = tag_id
        }
        this.higienizar()
      }

  },

  destroyed(){
    this.socket.off('canal_home_torneio');
  }

}
</script>

<style scoped>
  .form-control {
      color: #ffffff80;
      background-color: #333644;
      border: none;
  }

  .tag{
    float: left;
    padding-right: 15px;
  }

  /* Largura da barra de rolagem */
  ::-webkit-scrollbar {
    width: 10px; /* largura */
    height: 5px; /* altura */
  }

  /* Cor da barra de rolagem */
  ::-webkit-scrollbar-track {
    background: #0A0D1A;
  }

  /* Cor do indicador da posição atual da barra de rolagem */
  ::-webkit-scrollbar-thumb {
    background: #686868;
  }

  /* Arredondar as bordas do indicador da barra de rolagem */
  ::-webkit-scrollbar-thumb {
    border-radius: 5px;
  }
</style>


// WEBPACK FOOTER //
// src/components/home_torneio/home_torneio.vue